import { fromJS } from 'immutable';
import {
  SET_EXPERTISE_MISSIONS,
  SET_CLAIM_INFO,
  RESET_STORE_EXPERTISE,
} from 'containers/CourtManagerAssignedExpertise/constants';
import { SET_EXPERTISE_MISSION } from 'containers/ExpertAssignedMissionShow/constants';

const initialState = fromJS({
  expertiseMissions: [],
  expertiseMission: null,
  claimInfo: {},
});

const expertiseMissionsReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case SET_EXPERTISE_MISSIONS:
      return state.set('expertiseMissions', fromJS(action.payload));
    case SET_EXPERTISE_MISSION:
      return state.set('expertiseMission', fromJS(action.payload[0]));
    case SET_CLAIM_INFO:
      return state.set('claimInfo', fromJS(action.payload));
    case RESET_STORE_EXPERTISE:
      return initialState;
    default:
      return state;
  }
};

export default expertiseMissionsReducer;
